<template lang="pug">
    m-block-form-fields(:offset="false" :required="false")
        template(#title="") {{ $t(`modules.blocks.${name}.title`) }}

        template
            v-layout(wrap :class="name")
                v-flex(v-bind="getDividerPlacing")


                    v-layout(wrap justify-start v-if="item.username")
                        v-flex(xs12)
                            v-container(tag="dl")
                                e-typography-body-secondary(tag="dd" :class="bodySmallClass") {{ $t(`modules.blocks.${name}.text.username`) }}
                                e-typography-body(tag="dt") {{ item.username }}

                    v-layout(wrap justify-start v-if="item.position")
                        v-flex(xs12)
                            v-container(tag="dl")
                                e-typography-body-secondary(tag="dd" :class="bodySmallClass") {{ $t(`modules.blocks.${name}.text.position`) }}
                                e-typography-body(tag="dt") {{ item.position }}

                    v-layout(wrap justify-start)
                        v-flex(xs12)
                            v-container(tag="dl")
                                e-typography-body-secondary(tag="dd" :class="bodySmallClass") {{ $t(`modules.blocks.${name}.text.role`) }}
                                e-typography-body(tag="dt") {{ role }}

                    v-layout(wrap justify-start :class="`${name}__status`")
                        v-flex(xs12)
                            m-list-user-attributes(:item="item")
</template>

<script>
    import MBlockFormFields from "@modules/blocks/form/m-block-form-fields";
    import MListUserAttributes from "@modules/lists/concrete/m-list-user-attributes";
    import arrangement from "@mixins/positioning/_arrangement";

    let name = 'm-block-user-profile-info';

    export default {
        name: name,
        mixins: [arrangement],
        components: {MBlockFormFields, MListUserAttributes},
        props: {
            name: {
                type: String,
                default: name
            },
            item: {
                type: Object,
                required: true
            }
        },
        computed: {
            role() {
                return this.$t('roles.' + this.item.roles[0] + '.title');
            }
        }

    }
</script>

<style lang="scss" scoped>
    .m-block-user-profile-info {
        .offset-sm0 {
            margin-left: 0 !important;
        }

        &__status {
          margin-top: 1rem !important;
        }
        dl {
          margin-top: 0.5rem;
          padding: 0px !important;
        }
  }
</style>
